import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { useDeprecatedComponentWarning } from '@nerdwallet/deprecate';
import { useIconProps } from '../useIconProps';

var Trash = function Trash(props) {
  useDeprecatedComponentWarning({
    component: 'Trash'
  });
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 2048 2048"
  }, useIconProps(props)), /*#__PURE__*/React.createElement("path", {
    d: "M1440 1600V640h160v1120H384V640h160v960h896zM736 640h160v800H736V640zm352 0h160v800h-160V640zm280-288h328v160H288V352h328l97-288h558zm-583 0h414l-43-128H828z"
  }));
};

Trash.displayName = 'Trash';

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var PropTypes = require('prop-types');

  Trash.propTypes = {
    className: PropTypes.string,
    color: PropTypes.string,
    size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    textAligned: PropTypes.bool
  };
}

export default Trash;